<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="">
        <div class="mt-3">
          <label class="txt-right required">Tên tập đoàn</label>
          <InputText
            v-model="name"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
          />
          <input class="input_tmp_validator" id="name" />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Số điện thoại</label>
          <InputText
            v-model="phone"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
          />
          <input class="input_tmp_validator" id="phone" />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Email</label>
          <InputText
            v-model="email"
            type="text"
            class="text-box input-text-box"
            placeholder="mail@example.com"
          />
          <input class="input_tmp_validator" id="email" />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Địa chỉ</label>
          <InputText
            v-model="addr"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập địa chỉ"
          />
          <input class="input_tmp_validator" id="addr" />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Người đại diện</label>
          <InputText
            v-model="contact_name"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
          />
          <input class="input_tmp_validator" id="contact_name" />
        </div>
        <!-- <div class="mt-3">
          <Checkbox v-model="active" :binary="true" />Hoạt động
        </div> -->
      </div>

      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
// import DropdownScrollable from '@/components/DropdownScrollable.vue';
import ApiRepository from "@/core/ApiRepository";

export default {
  components:{
    // DropdownScrollable
  },
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  data() {
    return {
      filters: {},
      active: true,
      ordinal: null,
      company: {},
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      name: "",
      phone: "",
      addr: "",
      email: "",
      contact_name: "",
      validationErrors: {},
    };
  },
  async mounted() {
      console.log("this.model",this.model)
      // await this.getListCompany();
      if (this.model !== undefined && Object.keys(this.model).length > 0) {
        this.active = this.model.active;
        this.name = this.model.name;
        this.phone = this.model.phone;
        this.addr = this.model.addr;
        this.email = this.model.email;
        this.contact_name = this.model.contact_name;
      }
  },
  methods: {
    backToList() {
      this.$emit("back");
    },
    async emitEvent(keyword) {
      this.$delete(this.filters, 'name');
      if (keyword) {
        this.filters.name = keyword;
      }
      await this.getListCompany();
    },
    async changeOffset(value) {
      this.offset = value;
      // await this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.filters, limit: 20, offset: this.offset}, {headers}).then((res) => {
          if (this.offset > 0) {
            this.items.push(...res.data.data.company);
          } else {
            this.items = res.data.data.company;
          }
          this.total = res.data.data.total;
          this.loading = false;
        }).catch((err) => {
            console.log(err);
            this.loading = false;
        })
      }
    },
    async validateData() {
      this.validationErrors = {};
      let name_add = document.getElementById("name");
      if (this.name == undefined || this.name == null || this.name == "") {
        name_add.setCustomValidity("Tên tập đoàn không được để trống!");
      } else if (this.name.length > 255) {
        name_add.setCustomValidity("Tên tập đoàn không được quá 255 ký tự!");
      } else {
        name_add.setCustomValidity("");
      }
      let phone_add = document.getElementById("phone");
      if (this.phone == undefined || this.phone == null || this.phone == "") {
        phone_add.setCustomValidity("Số điện thoại không được để trống!");
      } else {
        phone_add.setCustomValidity("");
      }
      let email_add = document.getElementById("email");
      if (this.email == undefined || this.email == null || this.email == "") {
        email_add.setCustomValidity("");
      } else if (!this.validateEmail()) {
        email_add.setCustomValidity("Email không đúng định dạng!");
      } else {
        email_add.setCustomValidity("");
      }
      let addr_add = document.getElementById("addr");
      if (this.addr == undefined || this.addr == null || this.addr == "") {
        addr_add.setCustomValidity("Địa chỉ không được để trống!");
      } else {
        addr_add.setCustomValidity("");
      }
      let contact_name_add = document.getElementById("contact_name");
      if (this.contact_name == undefined || this.contact_name == null || this.contact_name == "") {
        contact_name_add.setCustomValidity("Người liên hệ không được để trống!");
      } else {
        contact_name_add.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    validateEmail() {
      var re = /\S+@\S+\.\S+/;
      return re.test(this.email);
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }

      var params = {
        name: this.name,
        phone: this.phone,
        addr: this.addr,
        email: this.email,
        contact_name: this.contact_name,
        active: this.active,
      };
      console.log("saveData", params);
      this.$emit("save", params);
      // }
    }
  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.p-checkbox {
  margin-right: 1rem !important;
}
</style>
